function docReady(fn) {
    // see if DOM is already available
    if (
        document.readyState === 'complete' ||
        document.readyState === 'interactive'
    ) {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


function waitForElm(selector, disconnect = true) {
    return new Promise(resolve => {
        if (document.querySelector(selector) && document.querySelector(selector).offsetHeight > 0) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector) && document.querySelector(selector).offsetHeight > 0) {
                resolve(document.querySelector(selector));
                if (disconnect) observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

docReady(() => {
    let touchstartX = 0
    let touchendX = 0

    const updateCartUpsellIndex = (direction) => {
        let upsellItemsContainer = document.querySelector('.upsell-items__wrapper');
        let currentIndex = parseInt(upsellItemsContainer.dataset.index);
        let newIndex = currentIndex + direction;
        if (newIndex < 0) newIndex = 0;
        if (newIndex > 2) newIndex = 2;
        upsellItemsContainer.dataset.index = newIndex;
        document.querySelectorAll('.upsell-items__dot').forEach((dot) => dot.classList.remove('active'));
        document.querySelectorAll('.upsell-items__dot')[newIndex].classList.add('active');
        let upsellItemWidth = document.querySelector('#CartContainer').offsetWidth;
        upsellItemsContainer.style.setProperty('--offset', newIndex * -upsellItemWidth + 'px');
    }
        
    const checkDirection = () => {
        if (touchendX < touchstartX) updateCartUpsellIndex(1)
        if (touchendX > touchstartX) updateCartUpsellIndex(-1)
    }

    const updateArrowVisibility = () => {
        let upsellItemsContainer = document.querySelector('.upsell-items__wrapper');
        let currentIndex = parseInt(upsellItemsContainer.dataset.index);
        let upsellItems = document.querySelectorAll('.upsell-items .upsell-item');

        if (currentIndex == 0) {
            document.querySelector('.upsell-items__arrow--prev').classList.add('hidden');
        } else {
            document.querySelector('.upsell-items__arrow--prev').classList.remove('hidden');
        }
        if (currentIndex == upsellItems.length - 1) {
            document.querySelector('.upsell-items__arrow--next').classList.add('hidden');
        } else {
            document.querySelector('.upsell-items__arrow--next').classList.remove('hidden');
        }
    }


    document.addEventListener('touchstart', e => {
        if (!e.target.closest('.upsell-items')) return;
        e.stopPropagation()
        touchstartX = e.changedTouches[0].screenX
    })

    document.addEventListener('touchend', e => {
        if (!e.target.closest('.upsell-items')) return;
        e.stopPropagation()

        touchendX = e.changedTouches[0].screenX
        checkDirection()
    })

    document.addEventListener('touchmove', e => {
        if (!e.target.closest('.upsell-items')) return;

        e.stopPropagation()
        e.preventDefault()
        return false;
    }, { passive: false })  


    const updateCartUpsells = (upsellItems) => {
        let upsellItemsDots = document.querySelector('.upsell-items__dots');
        let upsellItemsContainer = document.querySelector('.upsell-items__wrapper');
        let upsellItemTemplate = document.querySelector('.upsell-item[data-template="true"]');
        if (!upsellItemsContainer || !upsellItemTemplate) {
            setTimeout(() => {
                updateCartUpsells(upsellItems);
            }, 500);
            return;
        }
        upsellItemsContainer.innerHTML = '';
        upsellItemsDots.innerHTML = '';
        
        upsellItemsContainer.style.positon = 'relative';

        upsellItems.map(async (item, i) => {
            let newUpsellItem = upsellItemTemplate.cloneNode(true);
            newUpsellItem.dataset.template = false;
            newUpsellItem.querySelector('[data-upsell-image] img').src = item.featured_image;
            newUpsellItem.querySelector('[data-upsell-image]').setAttribute('href', item.url);
            newUpsellItem.querySelector('[data-upsell-title]').innerText = item.title;
            newUpsellItem.querySelector('[data-upsell-title]').setAttribute('href', item.url);
            newUpsellItem.querySelector('[data-upsell-price]').innerText = `${Shopify.formatMoney(item.price)}`;
            newUpsellItem.querySelector('[data-oke-star-rating]').dataset.okeReviewsProductId = 'shopify-' + item.id;

            newUpsellItem.dataset.id = item.variants[0].id;
            newUpsellItem.dataset.index = i;
            newUpsellItem.querySelector('[data-upsell-atc]').addEventListener('click', (e) => {
                let variantId = item.variants[0].id;
                let quantity = 1;
    
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity
                    })
                }).then((res) => {
                    return res.json();
                }).then((json) => {
                    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem')); 
                });
            });

            upsellItemsContainer.appendChild(newUpsellItem);
            await window.okeWidgetApi.setProduct(newUpsellItem.querySelector('[data-oke-star-rating]'), 'shopify-' + item.id);

            upsellItemsDots.innerHTML += `<span class="upsell-items__dot ${i == 0 ? 'active' : ''}" data-index="${i}"></span>`;
        })
        
        let dots = document.querySelectorAll('.upsell-items__dot');
        dots.forEach((dot) => {
            dot.addEventListener('click', (e) => {
                let index = e.target.dataset.index;
                dots.forEach((dot) => dot.classList.remove('active'));
                dot.classList.add('active');
                upsellItemsContainer.dataset.index = index;
                let upsellItemWidth = document.querySelector('#CartContainer').offsetWidth;
                upsellItemsContainer.style.setProperty('--offset', index * -upsellItemWidth + 'px');
                updateArrowVisibility();
            })
        });

        updateArrowVisibility();
        document.querySelector('.upsell-items').classList.remove('upsell-items__loading');

        waitForElm('.upsell-items .upsell-item').then((elm) => {
            let maxHeight = 0;

            document.querySelectorAll('.upsell-items .upsell-item').forEach((item) => {
                let height = item.offsetHeight;
                if (height > maxHeight) maxHeight = height;
            });
            upsellItemsContainer.style.height = (maxHeight + 60) + 'px';
            upsellItemsContainer.style.positon = 'absolute';
        });
    }

    const getCartUpsells = async (cart) => {
        let upsellItemRequests = [];
        
        let limit = 1;
        if (cart.items.length == 1) {
            limit = 3;
        } else if (cart.items.length < 3) {
            limit = 2;
        }

        cart.items.map(async (item, i) => {
            if (i > 2) return;
            let recommendations = fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=${10}`).then((res) => res.json());
            upsellItemRequests.push(recommendations);
        });
        let responses = await Promise.all(upsellItemRequests);
        let upsellItems = [];
        responses.map((response) => {
            let count = 0;
            response.products.map((product) => {
                if (upsellItems.length >= 3 || count > limit || product.tags.indexOf('locked') > -1) return;
                count++;
                upsellItems.push(product)
            });
        });
        let upsellTitle = document.querySelector('.upsell-title');
        if (upsellItems.length > 0) {
            if (upsellTitle) upsellTitle.classList.add('not-empty');
        } else {
            if (upsellTitle) upsellTitle.classList.remove('not-empty');
        }
        updateCartUpsells(upsellItems);
    }

    const updateGiftCount = (cart) => {
        let giftBox = document.querySelector('[name="gift"]');
        if (!giftBox) return;
        let giftBoxContainer = giftBox.parentElement;
        if (giftBox) {
            let totalItems = 0;
            cart.items.map((item) => {
                if (window.giftProducts.products.find((product) => product.indexOf(item.product_id) > -1)) {
                    totalItems += item.quantity;
                }
            });
            giftBox.dataset.giftCount = totalItems;
            if (giftBox.dataset.giftCount > 0 && giftBoxContainer.classList.contains('visually-hidden')) {
                giftBoxContainer.classList.remove('visually-hidden');
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: giftBox.dataset.giftBox,
                        quantity: totalItems
                    })
                }).then((res) => {
                    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
                });
            } else if (giftBox.dataset.giftCount == 0 && !giftBoxContainer.classList.contains('visually-hidden')) {
                giftBoxContainer.classList.add('visually-hidden');
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: giftBox.dataset.giftBox,
                        quantity: totalItems
                    })
                }).then((res) => {
                    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
                });
            }
        }
    }

    let initialized = false;

    const init = async () => {
        if (initialized) return;
        initialized = true;
        let cart = await fetch('/cart.js');
        let cartJson = await cart.json();

        getCartUpsells(cartJson);

        let upsellItemsArrowPrev = document.querySelector('.upsell-items__arrow--prev');
        let upsellItemsArrowNext = document.querySelector('.upsell-items__arrow--next');
        
        if (!upsellItemsArrowPrev || !upsellItemsArrowNext) return;
        upsellItemsArrowPrev.addEventListener('click', () => {
            updateCartUpsellIndex(-1);
            updateArrowVisibility();
        });
        upsellItemsArrowNext.addEventListener('click', () => {
            updateCartUpsellIndex(1);
            updateArrowVisibility();
        });

    }


    waitForElm('.upsell-items').then(async () => {
        init();
    });

    setTimeout(() => {
        init();
    }, 15000);

    document.body.addEventListener('baseline:modalcart:itemcountupdate', async () => {
        let cart = await fetch('/cart.js');
        let cartJson = await cart.json();
        getCartUpsells(cartJson);
        updateGiftCount(cartJson);

        let cartItems = document.querySelectorAll('div[data-cart-item-key]');
        cartItems.forEach((item) => {
            let key = item.dataset.cartItemKey;
            if (key.indexOf(window.giftItem) > -1) {
                item.classList.add('gift-item');
                item.style.order = cartItems.length - 1;
            }
        });
    });

    let collectionTemplate = document.querySelector('.template-collection');
    let blogTemplate = document.querySelector('.template-blog');

    if (collectionTemplate || blogTemplate) {
        let pagination = document.querySelector('.pagination').parentElement;
        let contentSelector = !collectionTemplate ? '.articles-list' : '.collection-list';
        let currCollection = document.querySelector(contentSelector);
        let spinner = document.querySelector('.loading-display');
        const scrollListener = async () => {
            let scrollY = window.scrollY;
            let scrollBottom = scrollY + window.innerHeight;
            let nextButton = pagination.querySelector('.pagination--next');
            if (scrollBottom > pagination.offsetTop && !spinner.classList.contains('pagination-loading') && nextButton) {
                spinner.classList.add('pagination-loading');
                let nextPage = await fetch(nextButton.href);
                let nextPageHtml = await nextPage.text();
                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(nextPageHtml, "text/html");
                let collection = htmlDocument.querySelector(contentSelector);
                let newPagination = htmlDocument.querySelector('.pagination').parentElement;
                let fillerBlock = currCollection.querySelector('.filler-block');
                if (fillerBlock) fillerBlock.remove();
                let fillerBlockNew = collection.querySelector('.filler-block');
                if (fillerBlockNew) fillerBlock.remove();
                currCollection.innerHTML += collection.innerHTML;
                pagination.innerHTML = newPagination.innerHTML;
                spinner.classList.remove('pagination-loading');
            }
        }

        setTimeout(() => {
            window.addEventListener('scroll', scrollListener);
        }, 3000);
        
    }

    class GiftBox extends HTMLElement {
        listener = null;
        giftBox = null;
    
        constructor() {
            super();
            this.giftBox = this.querySelector('[name="gift"]');
        }
    
        connectedCallback() {
            let cartLoader = document.querySelector('.cart-loader');
    
            if (!this.listener) {
                this.clearInvalidGifts();
                setInterval(() => {
                    this.clearInvalidGifts();
                }, 3000);
                this.listener = this.giftBox.addEventListener('change', async (e) => {
                    if (e.target.checked) {
                        let totalItems = this.giftBox.dataset.giftCount;
                        cartLoader.classList.add('loading-display');
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: this.giftBox.dataset.giftBox,
                                quantity: totalItems
                            })
                        }).then((res) => {
                            document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem')); 
                            cartLoader.classList.remove('loading-display');
                        });
                    } else {
                        cartLoader.classList.add('loading-display');
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: this.giftBox.dataset.giftBox,
                                quantity: 0
                            })
                        }).then((res) => {
                            document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem')); 
                            cartLoader.classList.remove('loading-display');
                        });
                    }
                });
            }
        }
    
        async clearInvalidGifts() {
            let cartLoader = document.querySelector('.cart-loader');
            let cart = await fetch('/cart.js');
            let cartJson = await cart.json();
            updateGiftCount(cartJson);
        } 
    
    }
    
    customElements.define('gift-box', GiftBox);
});
